import React from 'react';
import avatar2 from '../../assets/images/contact/manager.png';
import avatar1 from '../../assets/images/contact/owner.png';
import ContactForm from './ContactForm';
import OwnerCard from './OwnerCard';

function ContactSection() {
  return (
    <section className="contact-wrapper section-padding">
      <div className="container">
        <div className="row align-items-center gy-5 gy-lg-0">
          <div className="col-lg-6">
            <div className="left-content">
              <div className="section-head">
                <span className="heading-bg">Contact</span>
                <h2 className="section-title">
                  Get in touch
                  <span className="heading-dot" />
                </h2>
                <p className="body-text mt-20 mb-30">
                  After you submit your request using this form, we will answer
                  any of your questions within 15 minutes.
                </p>
              </div>
              <div className="contact-profile">
                <OwnerCard
                  avatar={avatar1}
                  name="Alexander Thompson"
                  designation="Owner of company"
                  phone="+1 302 246 1030"
                  email="alex@example.com"
                />

                <OwnerCard
                  avatar={avatar2}
                  name="Josephine Lopez"
                  designation="Owner of company"
                  phone="+1 302 246 1040"
                  email="jose@example.com"
                  marginTop
                />
              </div>
            </div>
          </div>
          <div className="col-lg-5 offset-lg-1">
            <div className="right-content">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
